import { Link } from "react-router-dom";
import type { Article } from "@/types/news";
import { formatViews } from "@/utils/articles";

interface HotRankingProps {
  articles: Article[];
}

export default function HotRanking({ articles }: HotRankingProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-5 h-14 border-b border-background-200">
        <div className="flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-600">
            <i className="ri-fire-line text-lg" aria-hidden="true" />
          </span>
          <h2 className="font-heading text-base font-bold text-foreground-950">热门爆料榜</h2>
        </div>
        <span className="text-[11px] font-label tracking-wider text-foreground-400">BY VIEWS</span>
      </div>

      <ol className="px-4 md:px-5 py-2">
        {articles.map((article, index) => (
          <li key={article.id} className="border-b border-background-100 last:border-b-0">
            <Link
              to={`/detail/${article.id}`}
              className="group flex items-start gap-3 py-3 cursor-pointer"
            >
              <span
                className={`shrink-0 w-6 h-6 flex items-center justify-center font-label font-bold text-sm rounded ${
                  index === 0
                    ? "bg-primary-600 text-background-50"
                    : index === 1
                      ? "bg-primary-100 text-primary-800"
                      : index === 2
                        ? "bg-accent-100 text-accent-900"
                        : "bg-background-100 text-foreground-400"
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-heading text-sm font-bold leading-snug text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </span>
                <span className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500 font-label">
                  <span className="inline-flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line" aria-hidden="true" />
                    </span>
                    {formatViews(article.views)}
                  </span>
                  <span className="w-px h-2.5 bg-background-300" />
                  <span>{article.region}</span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}